import { css } from "@emotion/css";
import * as React from "react";
import { navigate } from "../support/hashRouting";

export const DebugNavigationButton = ({
  url,
  displayText
}: {
  url: string;
  displayText: string;
}) => {
  const gotoUrl = () => {
    navigate(url);
  };

  const navigationButtonCss = css`
    background: none !important;
    color: inherit;
    border: none;
    padding: 0 !important;
    font: inherit;
    /*border is optional*/
    cursor: pointer;
  `;

  return (
    <li>
      <button type="button" className={navigationButtonCss} onClick={gotoUrl}>
        {displayText}
      </button>
    </li>
  );
};
